import { Components, checkboxClasses, Theme } from '@mui/material';

/**
 * Component overrides (i.e. global styles, default props) applied to
 * MuiCheckbox to make it match the design system.
 *
 * See: https://mui.com/material-ui/api/checkbox/#css
 */
export const MuiCheckbox: Components<Theme>['MuiCheckbox'] = {
  styleOverrides: {
    root: ({ theme }) => {
      if (theme.featureFlags.panwRebrandStubYear) {
        return {
          // Slightly tighter than MUI default so hover/focus halo sits closer to the checkbox.
          // Making up the spacing difference using margin
          padding: theme.spacing(0.6),
          margin: theme.spacing(0.4),
          color: theme.palette.border.bold,

          [`&:hover:not(.${checkboxClasses.disabled})`]: {
            backgroundColor: theme.palette.background.hover,
            borderRadius: theme.shape.controlRadius,
            [`&:not(.${checkboxClasses.checked}, .${checkboxClasses.indeterminate})`]: {
              color: theme.palette.border.inverse,
            },
          },

          [`&.${checkboxClasses.checked}, &.${checkboxClasses.indeterminate}`]: {
            color: theme.palette.interactive.control.selected,
            [`&:hover:not(.${checkboxClasses.disabled})`]: {
              color: theme.palette.interactive.control.selectedHover,
            },
          },

          [`&.${checkboxClasses.disabled}`]: {
            color: theme.palette.interactive.control.disabled,
          },
        };
      }

      return {
        color: theme.palette.border.bold,

        '&:hover': {
          backgroundColor: theme.palette.background.hover,
          borderRadius: '4px',

          [`&:not(.${checkboxClasses.checked}, .${checkboxClasses.indeterminate})`]: {
            color: theme.palette.text.legacySecondary,
          },
        },

        [`&.${checkboxClasses.disabled}`]: {
          color: theme.palette.border.default,
        },
      };
    },
  },
};
